import React, { useState } from 'react'
import { Instagram, Facebook, LinkedIn, YouTube } from '@material-ui/icons';
import { Tooltip } from 'reactstrap';


const Socialmedia = (props) => {

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => {
        setTooltipOpen(!tooltipOpen);
    }

    const setlink = (key) => {
        switch (key) {
            case "youtube": return "https://www.youtube.com/channel/UC_HTcLcesFzGIjclM_ATCBQ";
            case "facebook":return "https://www.facebook.com/pranesh.ramesh/";
            case "instagram":return "https://www.instagram.com/pranesh_ramesh/";
            case "linkedin":return "https://www.linkedin.com/in/pranesh-ramesh-487985104";

            default: return "";

        }
    }

    const seticon= (key) => {
        switch (key) {
            case "youtube": return (
                <YouTube id={props.id} ></YouTube>
            )
             case "facebook":return(
                 <Facebook id={props.id}></Facebook>
             )   
             case "instagram":return(
                <Instagram id={props.id}></Instagram>
            )  
            case "linkedin":return(
                <LinkedIn id={props.id}></LinkedIn>
            )  

            default: return "";

        }
    }
    return (<div>
        <a href={setlink(props.id)}>
        {seticon(props.id)}
            </a>
        <Tooltip placement="bottom" isOpen={tooltipOpen} target={props.id} toggle={toggle}>
            {props.id}
        </Tooltip>
    </div>
    )

}



export default Socialmedia